import styled from "styled-components";
import { useState } from "react";
import { RAButtonPrimary, RATextInput } from "@/components/customs";
import { Row, Col, Modal, Divider } from "antd";
import { IconCloseSvg } from "@/components/svgs";
import { isEmpty } from "lodash";
import { toast } from "@/modules/toast";
import { NOTIFICATION_TYPE, REGEX_PASSWORD } from "@/config/constants";
import { changeUserPassword } from "@/stores/apis/apiAuth";
import { HeaderSection } from "../../Cards";

const initFormChangePassword = {
	currentPassword: "",
	newPassword: "",
	newPasswordConfirm: "",
};

export function ModalChangeUserPassword({ visible = false, onClose, onChangePasswordSuccess }) {
	const [formChangePassword, setFormChangePassword] = useState(initFormChangePassword);
	const [error, setError] = useState({});

	const onSubmitChangePassword = async () => {
		let err = {};
		if (!formChangePassword.currentPassword || !formChangePassword?.currentPassword.trim()) {
			err.currentPassword = "Please enter current password.";
		}
		const regrex = new RegExp(REGEX_PASSWORD);
		if (!regrex.test(formChangePassword?.newPassword.trim())) {
			err.newPassword =
				"Password must contain at least 8 characters, at least one uppercase letter, one lowercase letter, one number and special character.";
		}
		if (!formChangePassword.newPassword || !formChangePassword?.newPassword.trim()) {
			err.newPassword = "Please enter new password.";
		}
		if (!formChangePassword.newPasswordConfirm || !formChangePassword?.newPasswordConfirm.trim()) {
			err.newPasswordConfirm = "Please enter confirm password.";
		}
		if (formChangePassword.newPassword !== formChangePassword?.newPasswordConfirm.trim()) {
			err.newPasswordConfirm = "Confirm password wrong.";
		}

		if (!isEmpty(err)) {
			setError(err);
			return;
		}

		const payload = {
			old_password: formChangePassword.currentPassword,
			new_password: formChangePassword.newPassword,
		};
		let response = await changeUserPassword(payload);
		if (response && response.success) {
			onChangePasswordSuccess?.(formChangePassword);
			setFormChangePassword(initFormChangePassword);
		} else {
			toast({
				type: NOTIFICATION_TYPE.ERROR,
				description: response?.error?.message || "Something went wrong. Please try again later.",
			});
		}
	};

	return (
		<Modal
			centered
			closeIcon={<IconCloseSvg />}
			open={visible}
			onCancel={() => {
				onClose(false);
				setFormChangePassword(initFormChangePassword);
			}}
			footer={null}
			width="auto"
			wrapClassName="auth-wrapper"
			style={{ padding: 0, margin: "20px 0px" }}
		>
			<Container data-testid="ChangePasswordModal_content">
				<Row>
					<Col md={24}>
						<HeaderSection
							title="Create New Password"
							description="Your new password must be different from the previous used password"
						/>
					</Col>
				</Row>
				<Divider />
				<Row gutter={[20, 20]}>
					<Col span={24}>
						<RATextInput
							data-testid="ChangePassword_currentPasswordInput"
							title="Current password"
							placeholder="Enter current password"
							value={formChangePassword.currentPassword}
							error={error?.currentPassword}
							type="password"
							onChange={(val) =>
								setFormChangePassword({
									...formChangePassword,
									currentPassword: val,
								})
							}
						/>
					</Col>
					<Col span={24}>
						<RATextInput
							data-testid="ChangePassword_newPasswordInput"
							title="New password"
							placeholder="Enter new password"
							value={formChangePassword.newPassword}
							error={error?.newPassword}
							type="password"
							onChange={(val) =>
								setFormChangePassword({
									...formChangePassword,
									newPassword: val,
								})
							}
						/>
					</Col>
					<Col span={24}>
						<RATextInput
							data-testid="ChangePassword_confirmPasswordInput"
							title="Confirm password"
							placeholder="Enter confirm password"
							value={formChangePassword.newPasswordConfirm}
							error={error?.newPasswordConfirm}
							type="password"
							onChange={(val) =>
								setFormChangePassword({
									...formChangePassword,
									newPasswordConfirm: val,
								})
							}
						/>
					</Col>
				</Row>
				<Row justify="center" align="middle" style={{ marginTop: "40px" }}>
					<RAButtonPrimary
						data-testid="ChangePassword_submitBtn"
						title="SUBMIT"
						onClick={() => onSubmitChangePassword()}
					/>
				</Row>
			</Container>
		</Modal>
	);
}

const Container = styled.div`
	padding-top: 30px;
	padding-bottom: 30px;
	width: 50vw;
	max-width: 620px;
	min-width: 343px;
	padding: clamp(24px, 8vw, 60px) clamp(16px, 4vw, 60px);
`;
